module.exports = __webpack_public_path__ + "static/media/Inter_18pt-Black.b797a429.ttf";